export default {"src":"/_next/static/media/cards-icon-4.9752f31c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};